/**
 * Notebook Agent Pill — floating action button
 * Shows when the hero section scrolls out of view.
 */
class NotebookAgentPill extends HTMLElement {
  connectedCallback() {
    // Find the hero section — look for notebook-hero class
    const hero = document.querySelector('.notebook-hero');
    if (!hero) {
      // No hero to observe, keep hidden
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.classList.remove('notebook-agent-pill--visible');
          this.setAttribute('aria-hidden', 'true');
        } else {
          this.classList.add('notebook-agent-pill--visible');
          this.setAttribute('aria-hidden', 'false');
        }
      },
      { threshold: 0.1 }
    );

    this.observer.observe(hero);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('notebook-agent-pill')) {
  customElements.define('notebook-agent-pill', NotebookAgentPill);
}
